import {createClient} from '@supabase/supabase-js';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {App} from './App';
import {registerPortalAuth} from './api';
import './design-system/theme.css';
import './styles.css';
import type {PortalConfig} from './types';

async function start(): Promise<void> {
  const root = createRoot(document.getElementById('root')!);
  try {
    const response = await fetch(import.meta.env.DEV ? '/api/local/config' : '/api/config');
    if (!response.ok) throw new Error('Teammate authentication has not been configured yet.');
    const config = (await response.json()) as PortalConfig;
    const supabase = createClient(config.supabaseUrl, config.supabasePublishableKey, {
      auth: {
        flowType: 'pkce',
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    });
    registerPortalAuth(supabase);
    root.render(
      <StrictMode>
        <App supabase={supabase} />
      </StrictMode>,
    );
  } catch (error) {
    root.render(
      <main className="centered-state">
        <section className="auth-card">
          <div className="brand-mark">M</div>
          <h1>Mentra Teammate</h1>
          <p>{error instanceof Error ? error.message : 'Portal initialization failed.'}</p>
        </section>
      </main>,
    );
  }
}

void start();
